import { getStoredUtms } from '../url';

/**
 * Returns UTMs + click IDs for the current session.
 * Reads from storage (not just the URL) so analytics events carry
 * attribution even after internal React Router navigation.
 */
export function getUTMParams() {
  return getStoredUtms();
}

/**
 * Enrichment data attached to every analytics event sent to the backend.
 */
export function getEnrichmentData() {
  const utms = getStoredUtms();

  return {
    source: 'web_app',
    platform: 'browser',
    ...utms,
    referrer: document.referrer || null,
    userAgent: navigator.userAgent,
  };
}
